// import objectFitImages from 'object-fit-images';
import { hasOwnProperty } from './tools/general'
// import 'v-calendar/src/styles/base.css'
import './assets/scss/main.scss'
import './behaviors/closings.behavior'
import 'lazysizes'

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit')
}

require('@/tools/windowresize')

window.lazySizes.cfg.loadMode = 1

import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import Stickyfill from 'stickyfilljs'
import ASVZ from './main/theme.js'
new ASVZ()

/**
 * @file
 * Theme generic.
 *
 */
;(function ($, Drupal, once) {
  if (typeof Drupal.views === 'undefined') {
    Drupal.views = {}
  }

  if (typeof Drupal.views.instances === 'undefined') {
    Drupal.views.instances = {}
  }

  Drupal.behaviors.hyphenation = {
    attach: function () {
      // $(".footer-navigation", context)
      // .find(".footer-navigation__second a")
      // .hyphenate("de");
    }
  }

  Drupal.behaviors.tracking = {
    attach: function () {
      $(once('bind-click-event', '.handorgel__header')).each(function () {
        $(this).on('click', function () {
          console.log()
          if ($(this).next().height() === 0) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'cta_accordion',
              cta_title: $(this).text().trim()
            })
          }
        })
      })

      $(
        once(
          'bind-click-event',
          '.swiper-wrapper .swiper-slide a.flex-column.box--3d'
        )
      ).each(function () {
        $(this).on('click', function () {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'cta_article',
            cta_article_title: $(this).find('h3').text(),
            cta_destination_path: $(this).attr('href')
          })
        })
      })
    }
  }

  Drupal.behaviors.stickyfill = {
    attach: function () {
      var selectors = [
        '.sticky',
        '.anchor-wrapper',
        '.facets-detail-wrapper',
        '.map-teaser',
        '.page-nav',
        '.teaser-list-calendar__header',
        '.teaser-list-calendar__date'
      ]
      var elements = document.querySelectorAll(selectors.join(','))
      Stickyfill.add(elements)
    }
  }

  Drupal.behaviors.responsiveColorBox = {
    attach: function () {
      if ($.colorbox) {
        $.colorbox.settings.onLoad = function () {
          colorboxResize()
        }
      }

      //Customize colorbox dimensions
      var colorboxResize = function (resize) {
        var width = '80%'
        var height = '80%'

        $.colorbox.settings.height = height
        $.colorbox.settings.width = width

        //if window is resized while lightbox open
        if (resize) {
          $.colorbox.resize({
            height: height,
            width: width
          })
        }
      }

      //In case of window being resized
      $(window).resize(function () {
        if ($.colorbox) {
          colorboxResize(true)
        }
      })
    }
  }

  Drupal.behaviors.navigation = {
    attach: function () {
      $(
        'a:not([tabindex]), button:not([tabindex]), input:not([tabindex])'
      ).attr('tabindex', '0')

      var menuBtnEl = document.getElementById('header-menu-btn')

      if (menuBtnEl) {
        $(once('bind-click-event', '#header-menu-btn')).each(function () {
          $(this).on('click', function () {
            if (
              document.body.classList.contains('body--header-search-active')
            ) {
              document.body.classList.remove('body--header-search-active')
              document.body.classList.remove('body--header-search-prepare')
            }
            if (document.body.classList.contains('search-open')) {
              document.body.classList.remove('search-open')
            }
            if (document.body.classList.contains('menu-open')) {
              document.body.classList.remove('menu-open')
              $('a, button, input').attr('tabindex', '0')
              $('.menu__link.menu__link--2.text-menu').attr('tabindex', '-1')
            } else {
              document.body.classList.add('menu-open')
              $('a, button, input').attr('tabindex', '-1')
              $('.menu__link.menu__link--2.text-menu').attr('tabindex', '0')
            }
          })
        })
      }

      document.addEventListener('keydown', (event) => {
        // Ignore IME composition
        if (event.isComposing || event.keyCode === 229) {
          return
        }

        // Close menu with ESC key
        if (event.key === 'Escape') {
          if (document.body.classList.contains('menu-open')) {
            document.body.classList.remove('menu-open')
            $('a, button, input').attr('tabindex', '0')
            $('.menu__link.menu__link--2.text-menu').attr('tabindex', '-1')

            menuBtnEl.focus()
          }
        }
      })
    }
  }

  Drupal.behaviors.search = {
    attach: function () {
      var searchBtnEl = document.getElementById('open-search')
      var searchInputEl = document.getElementById('search-header')
      var searchCloseEl = document.querySelectorAll(
        '.header-search__form .icon--close'
      )

      if (searchBtnEl) {
        searchBtnEl.addEventListener('click', function () {
          document.body.classList.add('search-open')
          document.body.classList.add('body--header-search-active')
          document.body.classList.add('body--header-search-prepare')

          searchInputEl.focus()

          if (document.body.classList.contains('menu-open')) {
            document.body.classList.remove('menu-open')
          }
        })
      }
      if (searchCloseEl) {
        searchCloseEl[0].addEventListener('click', function () {
          document.body.classList.remove('search-open')
          document.body.classList.remove('body--header-search-active')
          document.body.classList.remove('body--header-search-prepare')
        })
      }

      document.addEventListener('keydown', (event) => {
        // Ignore IME composition
        if (event.isComposing || event.keyCode === 229) {
          return
        }

        // Close menu with ESC key
        if (event.key === 'Escape') {
          if (document.body.classList.contains('search-open')) {
            document.body.classList.remove('search-open')
            document.body.classList.remove('body--header-search-active')
            document.body.classList.remove('body--header-search-prepare')
            searchBtnEl.focus()
          }
        }
      })
    }
  }

  /**
   * Attaches the Flex Grid behavior to Views.
   */
  Drupal.behaviors.TeaserSlider = {
    attach: function (_context, settings) {
      if (settings && settings.views && settings.views.swiper) {
        var DrupalSlider = window.drupalSettings.views.swiper

        for (var i in DrupalSlider) {
          if (hasOwnProperty(DrupalSlider, i)) {
            Drupal.views.instances[i] =
              Drupal.behaviors.TeaserSlider.setupSwiper(DrupalSlider[i])
          }
        }
      }
      var codes = document.querySelectorAll('.swiper-slide-duplicate a')

      for (var e = 0, len = codes.length; e < len; e++) {
        codes[e].setAttribute('tabindex', '-1')
      }
    },

    setupSwiper: function (settings) {
      var selector = '#swiper-dom-id-' + settings.view_dom_id
      var count = settings.num_slides
      var swiperContainer = document.querySelector(selector)
      var swiperwrapper = swiperContainer.querySelector('.swiper-wrapper')
      var amountOfSlides = swiperwrapper.childElementCount

      const nextEl = swiperContainer.nextElementSibling
      const prevEl = swiperContainer.previousElementSibling

      let noFixedWidth = ''

      if (count === 4) {
        noFixedWidth = 'auto'
      }

      let swiperOptions = {
        preloadImages: false,
        lazyLoading: true,
        slidesPerView: noFixedWidth ? noFixedWidth : Math.min(1, count),
        spaceBetween: 16,
        speed: 600,
        freeMode: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          1140: {
            slidesPerView: noFixedWidth ? noFixedWidth : Math.min(3, count),
            spaceBetween: 24
          },
          961: {
            slidesPerView: noFixedWidth ? noFixedWidth : Math.min(2, count),
            spaceBetween: 24
          },
          641: {
            slidesPerView: noFixedWidth ? noFixedWidth : Math.min(2, count),
            spaceBetween: 16
          }
        },
        navigation: {
          nextEl,
          prevEl
        },
        pagination: {
          el: '.swiper-pagination'
        },
        paginationClickable: true,
        modules: [Navigation, Pagination]
      }

      if (
        swiperContainer.hasAttribute('data-style') &&
        swiperContainer.getAttribute('data-style') === 'frontpage_sport_list'
      ) {
        var parent = $(selector + ' .swiper-wrapper')
        var divs = Array.from(parent.children)

        while (divs.length) {
          parent.append(
            divs.splice(Math.floor(Math.random() * divs.length), 1)[0]
          )
        }
        swiperOptions.loop = true
        swiperOptions.slidesPerGroup = 4
        swiperContainer.parentElement.classList.add('frontpage-sport-list')
      }

      if (amountOfSlides >= 10 || amountOfSlides <= 1) {
        swiperOptions.pagination.el = ''
      }

      new Swiper(selector, swiperOptions)
    }
  }
})(window.jQuery, window.Drupal, window.once)

if (module.hot) {
  module.hot.accept()
}
